import { render, staticRenderFns } from "./areaMap.vue?vue&type=template&id=1120250a&"
import script from "./areaMap.vue?vue&type=script&lang=js&"
export * from "./areaMap.vue?vue&type=script&lang=js&"
import style0 from "./areaMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports